import axios from 'axios'

const config = { timeout: 10000 }

const api = axios.create({
    timeout: config.timeout,
})

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token')
        if (token) {
            // // @ts-ignore
            config.headers = {
                ...config.headers,
                Authorization: `Bearer ${token}`,
            }
        }
        return config
    },
    (error) => Promise.reject(error),
)

export const getResourceCategories = (setCategories: (data: any[]) => void) => {
    api.get('/wp-json/wp/v2/categories').then(({ data }) => {
        const resourcesCategory = data.find(
            (category: { slug: string }) => category.slug === 'resources',
        )
        if (resourcesCategory) {
            setCategories(
                data.filter((category: { parent: number }) => category.parent === resourcesCategory.id),
            )
        } else {
            setCategories(data.filter((category: { slug: string }) => category.slug !== 'uncategorized'))
        }
    })
}

export const getCategoryPosts = (
    setPosts: (data: any[]) => void,
    categories: any[],
    postCount?: number,
) => {
    let query = '/wp-json/wp/v2/posts?_embed'
    if (postCount) {
        query += `&per_page=${postCount}`
    }
    query += `&categories=${categories.map((category) => category.id).join(',')}`

    api.get(query).then((response) => setPosts(response.data))
}

export default api
